import {useLayout} from '../layout/core'
import {ThemeModeComponent} from '../assets/ts/layout'

/** App logo path (change here to switch logo globally) */
export const APP_LOGO_PATH = '/media/logos/logo-main-svg.svg'

export const toAbsoluteUrl = (pathname: string) => pathname

/** Full URL for the app logo (uses APP_LOGO_PATH) */
export const getAppLogoUrl = () => toAbsoluteUrl(APP_LOGO_PATH)
export const useIllustrationsPath = (illustrationName: string): string => {
  const {config} = useLayout()

  const extension = illustrationName.substring(
    illustrationName.lastIndexOf('.'),
    illustrationName.length
  )
  const illustration =
    ThemeModeComponent.getMode() === 'dark'
      ? `${illustrationName.substring(0, illustrationName.lastIndexOf('.'))}-dark`
      : illustrationName.substring(0, illustrationName.lastIndexOf('.'))
  return toAbsoluteUrl(
    `/media/illustrations/${config.illustrations?.set}/${illustration}${extension}`
  )
}
